// eslint-disable-next-line @typescript-eslint/no-explicit-any
const arr = (len: number, mapper: () => any): any[] =>
  new Array(len).fill(undefined).map(mapper);

export default arr;
